import emit from '../../../common/events';
import { getAnalyticsSafeData } from '../../user-profile/user-profile.selectors';
import { UserProfile } from '../../user-profile/user-profile.interface';
import { getAppFlow, getUserActiveTab } from '../../user-profile/utils/user-profile.util';

export class MyInformationFormAnalytics {
  static schoolSelected(element: Element, selectedSchool: any): void {
    emit({
      element,
      name: 'mhecomm-school-selected',
      detail: { id: 'schoolSearch', selectedSchool },
    });
  }

  static departmentSelected(element: Element, user: UserProfile, selectedDepartment: any, selectedSchool: any): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-department-select',
        label: 'Department',
        comp: 'select',
        selectedDepartment,
        selectedSchool,
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static addSchool(element: Element, user: UserProfile, label: string): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-add-school-button',
        label,
        comp: 'button',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static removeSchool(element: Element, user: UserProfile, label: string, removedAffiliation: any, removedDepartment: any): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-remove-school-button',
        label,
        comp: 'button',
        removedSchool: {
          orgName: removedAffiliation.orgName,
          orgCity: removedAffiliation.orgCity,
          orgState: removedAffiliation.orgState,
          orgCountry: removedAffiliation.orgCountry,
          orgXid: removedAffiliation.orgXid,
        },
        removedDepartment,
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static editMyInformation(element: Element, user: UserProfile, label: string): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-edit-information-button',
        label,
        comp: 'button',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static saveChanges(element: Element, user: UserProfile, label: string): void {
    emit({
      element,
      name: 'submit',
      detail: {
        id: 'my-account-update-user-information-button',
        label,
        comp: 'button',
        user: getAnalyticsSafeData(user, true),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static openAddSchoolForm(element: Element, user: UserProfile): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-open-add-school-form-button',
        label: '+ Add a School',
        comp: 'button',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static startEditDepartment(element: Element, user: UserProfile, hasExistingDepartment: boolean): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: hasExistingDepartment ? 'my-account-edit-department-button' : 'my-account-add-department-button',
        label: hasExistingDepartment ? 'Edit' : '+ Add Department',
        comp: 'button',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static saveDepartmentEdit(element: Element, user: UserProfile): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-save-department-edit-select',
        label: 'Department',
        comp: 'select',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }

  static cancel(element: Element, user: UserProfile): void {
    emit({
      element,
      name: 'click',
      detail: {
        id: 'my-account-cancel-edit-button',
        label: 'Cancel',
        comp: 'button',
        user: getAnalyticsSafeData(user),
        appFlow: getAppFlow(),
        myAccountSection: getUserActiveTab(),
      },
      dataLayer: true,
    });
  }
}
